import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export const selectPaymentsState = createSelector(
  (state: RootState) => state.payments,
  (payments) => payments
);

export const selectPaymentsData = createSelector(
  selectPaymentsState,
  (paymentStatus) => paymentStatus.data?.results
);

export const selectPaymentsPaginate = createSelector(
  selectPaymentsState,
  (paymentStatus) => paymentStatus.data
);
